<!-- 专栏搜索 -->
<template>
	<div class="column-search">
		<search :keyWords="searchKeyWord" @goSearch="getSearchList"></search>
		<row-item-list :list="searchList"></row-item-list>
		<div class="recommend">
			<h3>推荐</h3>
			<row-item-list :list="recommendList"></row-item-list>
		</div>
	</div>
</template>
<script>
	import Search from "../../components/Search";
	import RowItemList from "../../components/RowItemList"
	import {ColumnSearch,ColumnRecommend} from "../../config/interface.js"
	export default{
		components:{
			Search,
			RowItemList
		},
		data(){
			return{
				searchKeyWord:'',    //搜索关键词
				searchList:[],       //搜索的结果列表
				recommendList:[],    //推荐列表
			}
		},
		mounted(){
			this.searchKeyWord=this.$route.query.searchKeyWord;
			this.getSearchList(this.searchKeyWord);
			this.getRecommendList();
		},
		methods:{
			//搜索列表
			getSearchList(searchKeyWord){
				if(searchKeyWord!=''){
					const url=ColumnSearch;
					const method='POST';
					let params={
						keywords:searchKeyWord
					}
					fetch(url,params,method)
					.then((res)=>{
						if(res.code==0){
							let data=res.data;
							let follow=data.follow_user_count;
							data.columns.forEach(function(item,index){
								item.follows=follow[item.id];
							})
							let searchList=[];
							searchList=data.columns;
							this.searchList=searchList;
						}
					})
				}else{
					this.searchList=[];
				}
			},
			//推荐列表
			getRecommendList(){
				const url=ColumnRecommend;
				const method='POST';
				let params={};
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						let follow=data.follow_user_count;
						data.columns.forEach(function(item,index){
							item.follows=follow[item.id];
						})
						let recommendList=[];
						recommendList=data.columns;
						this.recommendList=recommendList;
					}
				})
			}

		}
	}
</script>
<style lang="scss">
	.column-search{
		.recommend{
			h3{
				padding-left:12px;
				font-size:18px;
				line-height:40px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/Column/search.vue